import React, { useEffect, useState } from 'react';

const LoadingPage = ({ isOpen }) => {
  const [show, setShow] = useState(isOpen);
  const [fade, setFade] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setShow(true);
      setFade(true);
    } else {
      setFade(false); // bắt đầu fade-out
      const timer = setTimeout(() => {
        setShow(false); // ẩn hoàn toàn sau 0.3s
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  if (!show) return null;

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center bg-white bg-opacity-80 transition-opacity duration-300 ${
        fade ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <div className="relative w-12 h-12">
        {[...Array(8)].map((_, i) => (
          <span
            key={i}
            className="absolute w-2 h-2 bg-sky-500 rounded-full"
            style={{
              top: '50%',
              left: '50%',
              transform: `rotate(${i * 45}deg) translate(16px, -50%)`,
              animation: 'flowerPulse 1s linear infinite',
              animationDelay: `${i * 0.12}s`
            }}
          ></span>
        ))}
      </div>
      <style>
        {`
          @keyframes flowerPulse {
            0%, 80%, 100% { opacity: 0.3; }
            40% { opacity: 1; }
          }
        `}
      </style>
    </div>
  );
};

export default LoadingPage;
